import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css'; //Bootsrap 5 CSS
import 'bootstrap-icons/font/bootstrap-icons.css'; // Bootstrap Icon CSS
import './assets/css/sw-ui.css'; // SW-UI css
import './assets/css/style_v2.css'; // Cspoc V2 css
import { Provider } from 'react-redux';
import store from './Redux/store';
import DashboardV2 from './DashboardV2';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import axios from 'axios';
import { dataUser } from './Component/Helpers/util';
import 'react-toastify/dist/ReactToastify.css';
import { Navigate } from 'react-router-dom';
import MonthlyReview from './Component/ManageDataReview/mothlyReview';
import Parking from './Component/ParkingAllotment/parking';
import Project from './projectSchedule';
import mixpanel from 'mixpanel-browser';
import ManageRoles from './Component/Page/ManageRoles';
import MealPlanTransaction from './Component/MealPlanTransaction';
import MealPlanUsers from './Component/MealPlanUsers/MealPlanUsers';
import SurveyManagement from './Component/SurveyManagement';
import TicktingManagement from './Component/TicktingManagement';
import WalletLanding from './Component/WalletPoint/WalletLanding';
import CompanyWallet from './Component/WalletPoint/CompanyWallet';
import PrivateRoute from './utils/routes/PrivateRoute';
import RoomManagement from './Component/RoomManagement';
import RoomBooking from './Component/RoomBooking';
import PointDistribution from './Component/WalletPoint/PointDistribution';
import CompanyPointCrReport from './Component/CompanyPointCrReport';
import SnagManagement from './Component/SnagManagement';
import LandingPageNew from './Component/RewardPoints/LandingPageNew';
import ActiveMember from './Component/ActiveMember';
import CustomerPortal from './Component/CustomerPortal/CustomerPortal';
import LegalAndCompliance from './Component/LegalAndCompliance';
import ParkPlus from './Component/ParkingAllotment/ParkPlus';
import SeatBooking from './Component/SeatBooking';
import SeatManagement from './Component/SeatManagement';
import Roster from './Component/Roster/Roster';
import Department from './Component/Department/Department';
import BookingInfoseat from './Component/bookingInfoseat';
import LightGridInfo from './Component/LightGrid/LightGridInfo';
import VisitorManagement from './Component/VisitorManagement';
import CompanyPointReport from './Component/CompanyPointReport';
import TataTeleService from './Component/RewardPoints/TataTeleService';
import AccessContrlReport from './Component/AccessContrlReport';
import BankDetails from './Component/WalletPoint/BankDetails';
import TopUpWallet from './Component/WalletPoint/TopUpWallet';
import PurchaseHistory from './Component/WalletPoint/PurchaseHistory';
import DeviceConfiguration from './Component/DeviceConfiguration';
import RfidReport from './Component/RfidReport';
import RewardIframe from './Component/RewardPoints/RewardIframe';
import GiftPointReward from './Component/RewardPoints/GiftPointReward';

import ParkSmart from './Component/ParkingAllotment/ParkSmart';

import NoAccessPage from './Component/NoAccessPage';


mixpanel.init('d554b944418a643b84da807ce83687c1', {
  debug: true,
});

const userDataLocal = dataUser();


let UserObj = userDataLocal ? JSON.parse(userDataLocal) : null;




class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company_id: UserObj ? UserObj?.company_id : null,
      userid: UserObj ? UserObj?.rec_id : null,
      locationData: [],
      userRoleData: [],
      leftMenuMeeting: UserObj ? UserObj?.service_add_on?.meeting_room : null,
      leftMenuAttendance: UserObj ? UserObj?.service_add_on?.attendance : null,
      leftMenuDesk: UserObj ? UserObj?.service_add_on?.desk_booking : null,
      userRole: UserObj && UserObj.role_data ? UserObj.role_data : [],
    };
  }

  componentWillMount() {
    const localDaata = JSON.parse(localStorage.getItem('headData'));
    let authToken = JSON.parse(localStorage.getItem('headData'));
    let param = {
      user_id: this.state.userid,
      client_id: this.state?.company_id,
    };
    axios
      .post(
        process.env.REACT_APP_API_URL + 'userRoles/get-user-role-access',
        param,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      )
      .then(response => {
        if ((response.data.status = 'success')) {
          this.setState({ userRole: response.data.data.userRoleData });
        }
      });
  }

  componentDidMount() {


    const userDataLocal = dataUser();
  let UserObj = userDataLocal ? JSON.parse(userDataLocal) : null;

  if (UserObj) {
    this.setState({
      leftMenuMeeting: UserObj?.service_add_on?.meeting_room ,// Fix: Default value
      leftMenuAttendance: UserObj?.service_add_on?.attendance ,
      leftMenuDesk: UserObj?.service_add_on?.desk_booking ,
      userRole: UserObj?.role_data || [],
    });
  }
    
    let authToken = JSON.parse(localStorage.getItem('headData'));
    let param = {
      user_id: this.state.userid,
      client_id: this.state?.company_id,
    };
    axios
      .post(
        process.env.REACT_APP_API_URL + 'userRoles/get-user-role-access',
        param,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      )

      .then(response => {
        this.setState({
          locationData: response.data.data?.locationData,
          userRoleData: response.data.data?.userRoleData,
        });
        let locIdArr = [];
        response.data.data.locationData.map(item => {
          locIdArr.push(item?.rec_id);
        });

        UserObj.role_data = [];

        response.data.data.userRoleData.map(item => {
          UserObj.role_data.push(item);
        });

        localStorage.setItem('locationData', JSON.stringify(locIdArr));
        localStorage.setItem('headData', JSON.stringify(UserObj));
        dataUser();
      });
    if (UserObj) {
      // this.getEmployeeCount(UserObj?.company_id);
    }
  }
  render() {
    const { leftMenuMeeting, leftMenuDesk, leftMenuAttendance, userRole } = this.state;

    const Compliance = userRole.find(element => element.service_id === '5');

   
    return (
      <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        pauseOnHover={false}
        pauseOnFocusLoss={false}
        closeOnClick
        // limit={3}
      />
        <Provider store={store}>
          <Router>
            <Routes>
              <Route
                path="/"
                element={<PrivateRoute element={<DashboardV2 />} />}
              />
              <Route
                path="/Dashboard"
                element={<PrivateRoute element={<DashboardV2 />} />}
              />
              <Route
                path="/project-schedule"
                element={<PrivateRoute element={<Project />} />}
              />
              <Route
                path="/ActiveMember"
                element={<PrivateRoute element={<ActiveMember />} />}
              />
              <Route
                path="/CustomerPortal"
                element={<PrivateRoute element={<CustomerPortal />} />}
              />
              <Route
                path="/meal-plan-users"
                element={<PrivateRoute element={<MealPlanUsers />} />}
              />
              <Route
                path="/meal-plan-report"
                element={<PrivateRoute element={<MealPlanTransaction />} />}
              />
              <Route
                path="/VisitorManagement"
                element={<PrivateRoute element={<VisitorManagement />} />}
              />
              <Route
                path="/SurveyManagementPage"
                element={<PrivateRoute element={<SurveyManagement />} />}
              />
              <Route
                path="/TicktingManagement"
                element={<PrivateRoute element={<TicktingManagement />} />}
              />
              <Route
                path="/SnagListManagement"
                element={<PrivateRoute element={<SnagManagement />} />}
              />

              <Route
                path="/park-plus"
                element={<PrivateRoute element={<ParkPlus />} />}
              />

              <Route
                path="/park-smart"
                element={<PrivateRoute element={<ParkSmart />} />}
              />

              <Route
                path="/Parking"
                element={<PrivateRoute element={<Parking />} />}
              />

              <Route
                path="/explore-wallet-point"
                element={<PrivateRoute element={<WalletLanding />} />}
              />
              <Route
                path="/wallet-dashboard"
                element={<PrivateRoute element={<CompanyWallet />} />}
              />
              <Route
                path="/point-distribution"
                element={<PrivateRoute element={<PointDistribution />} />}
              />
              <Route
                path="/redemption-report"
                element={<PrivateRoute element={<CompanyPointReport />} />}
              />
              <Route
                path="/distribution-report"
                element={<PrivateRoute element={<CompanyPointCrReport />} />}
              />
              <Route
                path="/tata-teleservice"
                element={<PrivateRoute element={<TataTeleService />} />}
              />
              <Route
                path="/corporate-gifting"
                element={<PrivateRoute element={<LandingPageNew />} />}
              />

              <Route
                path="/RoomBooking"
                element={<PrivateRoute element={<RoomBooking />} />}
              />
              <Route
                path="/Compliance"
                element={<PrivateRoute element={<Compliance />} />}
              />

              <Route
                exact
                path="/RoomManagement"
                element={
                  this.state.leftMenuMeeting == 1 ? (
                    <PrivateRoute element={<RoomManagement />} />
                  ) : (
                    <Navigate to="/Dashboard" />
                  )
                }
              />

              <Route
                exact
                path="/LegalAndCompliance"
                element={
                  Compliance &&
                  (Compliance.role_for_read == '1' ||
                    Compliance.role_for_write == '1') ? (
                    <PrivateRoute element={<LegalAndCompliance />} />
                  ) : (
                    <DashboardV2 />
                  )
                }
              />

              <Route
                path="/SeatBooking"
                element={
                  this.state.leftMenuDesk === 1 ? (
                  <PrivateRoute element={<SeatBooking />} />
                  ) : (
                    <Navigate to="/Dashboard" />
                  )
                }
              />

              <Route
                path="/SeatManagement"
                element={
                  this.state.leftMenuDesk === 1 ? (
                    <PrivateRoute element={<SeatManagement />} />
                  ) : (
                    <Navigate to="/Dashboard" />
                  )
                }
              />

              <Route
                path="/department"
                element={
                  this.state.leftMenuAttendance === 1 ||
                  this.state.leftMenuDesk === 1 ? (
                    <PrivateRoute element={<Department />} />
                  ) : (
                    <Navigate to="/Dashboard" />
                  )
                }
              />

              <Route
                exact
                path="/roster"
                element={
                  this.state.leftMenuDesk === 1 ? (
                    <PrivateRoute element={<Roster />} />
                  ) : (
                    <Navigate to="/Dashboard" />
                  )
                }
              />

              <Route
                exact
                path="/bookinginfoseat"
                element={
                  this.state.leftMenuDesk === 1 ? (
                    <PrivateRoute element={<BookingInfoseat />} />
                  ) : (
                    <Navigate to="/Dashboard" />
                  )
                }
              />

              <Route
                path="/monthlyReview"
                element={<PrivateRoute element={<MonthlyReview />} />}
              />

              <Route
                path="/bank-details"
                element={<PrivateRoute element={<BankDetails />} />}
              />
              <Route
                path="/topup-wallet"
                element={<PrivateRoute element={<TopUpWallet />} />}
              />
              <Route
                path="/purchase-history"
                element={<PrivateRoute element={<PurchaseHistory />} />}
              />

              <Route
                path="/ManageRoles"
                element={<PrivateRoute element={<ManageRoles />} />}
              />

              <Route
                path="/user-access-management"
                element={<PrivateRoute element={<DeviceConfiguration />} />}
              />
              <Route
                path="/access-logs"
                element={<PrivateRoute element={<AccessContrlReport />} />}
              />
              <Route
                path="/rfid-logs"
                element={<PrivateRoute element={<RfidReport />} />}
              />
              <Route
                path="/user-access-management"
                element={<PrivateRoute element={<DeviceConfiguration />} />}
              />
              <Route
                path="/lightgrid-info"
                element={<PrivateRoute element={<LightGridInfo />} />}
              />
              <Route
                path="/user-access-management"
                element={<PrivateRoute element={<DeviceConfiguration />} />}
              />
              <Route
                path="/bulk-gifting"
                element={<PrivateRoute element={<RewardIframe />} />}
              />
              <Route
                path="/reward-points"
                element={<PrivateRoute element={<GiftPointReward />} />}
              />

              <Route
                path="/no-access"
                element={<PrivateRoute element={<NoAccessPage />} />}
              />
            </Routes>
          </Router>
        </Provider>
      </>
    );
  }
}

export default App;
